import { Box, useMediaQuery, useTheme } from '@mui/material';
import Sidebar from '../Sidebar';
import tokens from '../../shared/theme/tokens';

export default function Layout({ children, fullWidth = false }) {
  const theme = useTheme();
  const mini = useMediaQuery(theme.breakpoints.down('md'));
  const sidebarWidth = mini ? tokens.layout.sidebarMiniWidth : tokens.layout.sidebarWidth;

  return (
    <Box sx={{ minHeight: '100vh', pl: `${sidebarWidth}px` }}>
      <Sidebar />
      <Box
        sx={{
          py: 3.5,
          px: 4,
          boxSizing: 'border-box',
          width: '100%',
          minWidth: 0,
          maxWidth: fullWidth ? 'none' : `${tokens.layout.contentMaxWidth}px`,
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
